import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { BaseActionData } from './base-action-data';

/**
 * Représente les données de l'action 'Archiver un dossier'.
 */
export class ArchiveFolderActionData extends BaseActionData {
    public waitingArchiveModeEnabled: boolean = false;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowActionTypes.ArchiveFolder);
    }

    /**
     * Retourne une copie d'une instance de ArchiveFolderActionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: ArchiveFolderActionData) {
        if (!!other) {
            const instance = new ArchiveFolderActionData();
            instance.type = other.type;
            instance.waitingArchiveModeEnabled = other.waitingArchiveModeEnabled;

            return instance;
        } else {
            return null;
        }
    }
}
